/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { DisturbanceRequest } from "../../../../sim/simulator/disturbances";

export const protobufPackage = "skills";

export interface SpoofDisturbanceActionActionArgs {
  disturbanceRequest: DisturbanceRequest | undefined;
}

export interface SpoofDisturbanceResultData {
}

export interface SpoofDisturbanceActionStateData {
}

function createBaseSpoofDisturbanceActionActionArgs(): SpoofDisturbanceActionActionArgs {
  return { disturbanceRequest: undefined };
}

export const SpoofDisturbanceActionActionArgs = {
  encode(message: SpoofDisturbanceActionActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.disturbanceRequest !== undefined) {
      DisturbanceRequest.encode(message.disturbanceRequest, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofDisturbanceActionActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofDisturbanceActionActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.disturbanceRequest = DisturbanceRequest.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofDisturbanceActionActionArgs {
    return {
      disturbanceRequest: isSet(object.disturbanceRequest)
        ? DisturbanceRequest.fromJSON(object.disturbanceRequest)
        : undefined,
    };
  },

  toJSON(message: SpoofDisturbanceActionActionArgs): unknown {
    const obj: any = {};
    if (message.disturbanceRequest !== undefined) {
      obj.disturbanceRequest = DisturbanceRequest.toJSON(message.disturbanceRequest);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofDisturbanceActionActionArgs>, I>>(
    base?: I,
  ): SpoofDisturbanceActionActionArgs {
    return SpoofDisturbanceActionActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofDisturbanceActionActionArgs>, I>>(
    object: I,
  ): SpoofDisturbanceActionActionArgs {
    const message = createBaseSpoofDisturbanceActionActionArgs();
    message.disturbanceRequest = (object.disturbanceRequest !== undefined && object.disturbanceRequest !== null)
      ? DisturbanceRequest.fromPartial(object.disturbanceRequest)
      : undefined;
    return message;
  },
};

function createBaseSpoofDisturbanceResultData(): SpoofDisturbanceResultData {
  return {};
}

export const SpoofDisturbanceResultData = {
  encode(_: SpoofDisturbanceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofDisturbanceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofDisturbanceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofDisturbanceResultData {
    return {};
  },

  toJSON(_: SpoofDisturbanceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofDisturbanceResultData>, I>>(base?: I): SpoofDisturbanceResultData {
    return SpoofDisturbanceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofDisturbanceResultData>, I>>(_: I): SpoofDisturbanceResultData {
    const message = createBaseSpoofDisturbanceResultData();
    return message;
  },
};

function createBaseSpoofDisturbanceActionStateData(): SpoofDisturbanceActionStateData {
  return {};
}

export const SpoofDisturbanceActionStateData = {
  encode(_: SpoofDisturbanceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofDisturbanceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofDisturbanceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofDisturbanceActionStateData {
    return {};
  },

  toJSON(_: SpoofDisturbanceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofDisturbanceActionStateData>, I>>(base?: I): SpoofDisturbanceActionStateData {
    return SpoofDisturbanceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofDisturbanceActionStateData>, I>>(_: I): SpoofDisturbanceActionStateData {
    const message = createBaseSpoofDisturbanceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
